module.exports = "<li class=\"gallery-lightbox__item gallery-lightbox__item--endslate js-gallery-slide\">\n<div class=\"gallery-lightbox__endslate js-gallery-endslate fc-container--media\"></div>\n</li>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/content/endslate.html
// module id = 720
// module chunks = 2